module.exports = __webpack_public_path__ + "static/media/brady.e72442b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brady.jpg
// module id = 350
// module chunks = 0